<template>
  <v-container>
    <div class="align-center">
      <span
        class="pl-2"
        style="font-size: 18px; font-weight: bold; color: #00a99d"
        >รายการยา</span
      >
    </div>

    <v-row class="pa-0 ma-0">
      <v-col cols="12">
        <div class="d-flex align-center">
          <span
            class="pr-2"
            style="font-size: 14px; font-weight: bold; color: #00a99d"
          >
            ข้อมูลรายการยา
          </span>
          <v-divider class="mt-1" style="background-color: #ceefed"></v-divider>
        </div>
      </v-col>
    </v-row>
    <v-row v-for="(drug, index) in itemDrug" :key="index" class="pl-2 pr-2">
      <v-col class="pa-1" cols="5">
        <div class="d-flex flex-column">
          <span style="font-size: 16px"> #{{ index + 1 }} รายการยา </span>
          <v-autocomplete
            solo
            hide-details="auto"
            dense
            :items="itemSearchDrug"
            @keyup="searchDrugList"
            @input="(e) => setDrug(e, index, 'list')"
            return-object
            item-text="name_drug"
            item-value="_id"
            placeholder="กรอกรายการยา"
          >
            <template v-slot:no-data>
              <v-list-item>
                <v-list-item-title> ไม่พบข้อมูล </v-list-item-title>
              </v-list-item>
            </template></v-autocomplete
          >
        </div>
      </v-col>
      <v-col class="pa-1" cols="2" align="center">
        <div class="d-flex flex-column">
          <span style="font-size: 16px"> จำนวน</span>
          <v-text-field
            type="number"
            solo
            hide-details="auto"
            dense
            @keypress="handleKeyPress"
            @input="(e) => setDrug(e, index, 'count')"
            v-model="itemDrug[index].count"
            :min="0"
            :max="CheckQuantity(itemDrug[index])"
            oninput="if(Number(this.value) < Number(this.min)) this.value = this.min;"
            :rules="[
              (v) =>
                (v >= 0 && v <= CheckQuantity(itemDrug[index])) || 'ยาไม่พอ',
            ]"
          ></v-text-field>
        </div>
      </v-col>
      <v-col class="pa-1" cols="2" align="center">
        <div class="d-flex flex-column">
          <span style="font-size: 16px">ราคา</span>
          <v-text-field
            solo
            hide-details="auto"
            dense
            v-model="itemDrug[index].sum"
            readonly
          ></v-text-field>
        </div>
      </v-col>
      <v-col class="pa-1" cols="3" align="center">
        <div class="d-flex flex-column">
          <div class="d-flex">
            <span style="font-size: 16px">ราคารวม</span>
            <v-spacer></v-spacer>
            <v-btn icon x-small @click="delDrug(index)">
              <v-icon color="red">mdi-close</v-icon>
            </v-btn>
          </div>
          <v-text-field
            solo
            hide-details="auto"
            dense
            :value="priceTakingMedicine(itemDrug[index])"
            small
            readonly
          ></v-text-field>
        </div>
      </v-col>

      <!-- ข้อมูลการรับยา -->
      <v-col class="pa-1" cols="1" align-self="center"></v-col>
      <v-col class="pl-2 pr-2" cols="12" align-self="center">
        <v-row class="usageAndAdvice" v-show="show">
          <v-col
            class="pa-1"
            cols="12"
            align-self="center"
            style="white-space: wrap; text-overflow: ellipsis"
          >
            <span class="w-700 font-14 text-313B41"> จำนวนยาในคลัง : </span>
            <span class="w-300 font-14 text-313B41"
              >{{ itemDrug[index].list_drug.quantity }}
            </span>
            <span> {{ itemDrug[index].list_drug.unit }} </span>
          </v-col>
        </v-row>
        <v-col class="pa-1" cols="1" align-self="center"></v-col>
        <v-row class="usageAndAdvice" v-show="show">
          <v-col
            class="pa-1"
            cols="12"
            align-self="center"
            style="white-space: wrap; text-overflow: ellipsis"
          >
            <span class="w-700 font-14 text-313B41"> ข้อมูลการใช้ยา : </span>
            <span class="w-300 font-14 text-313B41"
              >{{
                itemDrug[index].list_drug.usage
                  ? itemDrug[index].list_drug.usage
                  : "-"
              }}
            </span>
          </v-col>
          <v-col
            class="pa-1"
            cols="12"
            align-self="center"
            style="text-align: center"
          >
            <span class="w-700 font-12 text-EB5757">
              ***
              {{
                itemDrug[index].list_drug.advice
                  ? itemDrug[index].list_drug.advice
                  : "ไม่มี"
              }}
              ***
            </span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-col cols="12" lg="12" class="text-right">
      <v-btn icon @click="addDrug">
        <v-icon color="#00a99d">mdi-plus-circle</v-icon>
      </v-btn>
    </v-col>

    <v-row class="pl-2 pr-2 pt-3">
      <v-col class="pa-1" cols="7">
        <span class="w-300 font-18 text-313B41"
          >สรุปรายการยา {{ quantity(itemDrug) }} รายการ</span
        >
      </v-col>
      <v-col class="pa-1" cols="5" align="end">
        <span class="w-300 font-18 text-313B41">ราคารวม </span>
        <span class="w-300 font-18 text-3D85E1">
          <!-- {{ itemDrug[0].sum }} -->
          {{ netprice(itemDrug) }}
        </span>
        <span class="w-300 font-18 text-313B41"> บาท</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      itemDrug: [
        { list_drug: {}, price: "", count: "", sum: "" },
        { list_drug: {}, price: "", count: "", sum: "" },
      ],
      itemSearchDrug: [],
    };
  },
  watch: {
    itemDrug: {
      deep: true,
      handler(newVal) {
        newVal.forEach((item, index) => {
          if (isNaN(item.sum)) {
            this.$set(this.itemDrug[index], "sum", 0);
          }
        });
      },
    },
  },
  async mounted() {
    this.searchDrugList();
  },
  methods: {
    handleKeyPress(event) {
      const invalidChars = ["e", "E", "-", "."];
      if (invalidChars.includes(event.key)) {
        event.preventDefault();
      }
    },
    async searchDrugList(text) {
      try {
        let word = "";
        if (text === undefined) {
          word = "";
        } else word = text.target.value;
        await this.axios
          .get(
            `${process.env.VUE_APP_BACKEND_URL}/v1/druglists/search?biz_id=${sessionStorage.biz_id}&search=${word}`
          )
          .then((res) => {
            this.itemSearchDrug = res.data.data[0].data;
            console.log("itemSearchDrug", this.itemSearchDrug);
          });
        // if (data[0]) {
        //   const { data: dataSearch = {} } = data[0];
        //   this.itemSearchDrug = dataSearch;
        //   console.log("dddddddddddddddd", this.itemSearchDrug);
        // console.log(
        //   "🚀 ~ file: Tab3DrugRecords.vue:115 ~ searchDrugList ~ dataSearch:",
        //   dataSearch
        // );
        // }
        // if (result == "success") {

        // }

        // console.log("🚀 ~ file: Drug.vue:99 ~ getDrugList ~ data:", data);
      } catch (error) {
        console.error();
      }
    },
    addDrug() {
      this.itemDrug.push({ list_drug: {}, price: "", count: "", sum: "" });
    },
    delDrug(index) {
      if (index > -1) {
        // only splice array when item is found
        this.itemDrug.splice(index, 1); // 2nd parameter means remove one item only
      }
    },
    setDrug(event, index, type) {
      switch (type) {
        case "count":
          this.itemDrug[index].sum = parseFloat(
            parseFloat(this.itemDrug[index].price) * parseInt(event)
          );
          break;
        case "list":
          this.itemDrug[index].list_drug = event;
          this.itemDrug[index].count = 1;
          this.itemDrug[index].price = event.price;
          this.itemDrug[index].sum = event.price;
          this.show = true;
          break;
        case "price":
          this.itemDrug[index].price = event.price;
          break;
        default:
          break;
      }
    },
    quantity(itemDrug) {
      let quantity = 0;
      itemDrug.forEach((ele) => {
        if (ele.list_drug !== "") {
          quantity++;
        }
      });
      return quantity;
    },

    netprice(itemDrug) {
      let netprice = 0;
      itemDrug.forEach((ele) => {
        if (ele.list_drug !== "" && ele.count !== "") {
          netprice += Number(ele.count) * Number(ele.price);
        }
      });
      return netprice.toFixed(2);
    },

    CheckQuantity(item) {
      if (item && item.list_drug.quantity) {
        return item.list_drug.quantity;
      } else {
        return 0;
      }
    },
    priceTakingMedicine(item) {
      let price = 0;
      if (item.count !== "") {
        price = item.count * item.price;
      }
      return price.toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Sarabun&display=swap");
.left-content {
  width: 45%;
}
.right-content {
  width: 55%;
  margin-top: -12px;
}
.v-list-item-group .v-list-item--active {
  color: #fff;
  background: #0e535a;
}
.v-list-item {
  background: #e8f6f7;
  color: #000;
}
.usageAndAdvice {
  border: 1px solid #00000061;
  border-radius: 4px;
  margin: 0px;
}
::v-deep
  .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)
  > .v-input__control
  > .v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}
.noitems {
  height: 60vh;
}
</style>
